// Mock profile data for fallback when backend is unavailable
export const mockProfileData = {
  success: true,
  user_data: {
    id: 4,
    email: 'admin@test.com',
    role: 'admin',
    created_at: '2024-01-01T00:00:00Z'
  },
  employee_data: {
    first_name: 'Admin',
    last_name: 'User',
    phone: '+90 555 123 4567',
    department: 'Yönetim',
    position: 'Sistem Yöneticisi'
  },
  employee_found: false  // Employee data yok, sadece user var
};

// Function to get mock profile data
export const getMockProfile = () => {
  return new Promise((resolve) => {
    // Simulate network delay
    setTimeout(() => {
      resolve({ data: mockProfileData });
    }, 500);
  });
};
